import { defineComponent as _defineComponent } from 'vue'
import {desanitizeString} from "@/utils/Helpers";
import {PrintRecipeDetails} from "@/models/Recipes/PrintRecipeDetails";
import {DishRecipeCommon} from "@/models/DishRecipeCommon";
import {RecipeCompositionMeasurement} from "@/models/Recipes/RecipeCompositionMeasurement";
import {RecipeIngredient} from "@/models/Recipes/RecipeIngredient";
import {onUnmounted, ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vRecipeNutritionLabelPrintout',
  props: {
    recipe: null,
    printMeta: null,
    subrecipeServingSizes: null,
    ingredients: { default: () => [] },
    image: null,
    containsAllergensText: { default: "" }
  },
  emits: ["preview-url-generated"],
  setup(__props: any, { emit }) {

const props = __props as { recipe: DishRecipeCommon, printMeta: PrintRecipeDetails, subrecipeServingSizes: RecipeCompositionMeasurement[], ingredients: RecipeIngredient[], image: Blob, containsAllergensText: string };




const imageUrl = ref("");

watch(props, (newData) => {
  try {
    URL.revokeObjectURL(imageUrl.value);
  }

  catch (ex) {
    console.debug("Failed to revoke url: ", ex);
  }

  try {
    imageUrl.value = URL.createObjectURL(newData.image);
  }

  catch (ex) {
    console.debug("Failed to create url: ", ex);
  }

  finally {
    emit("preview-url-generated", imageUrl.value);
  }
});

onUnmounted(() => {
  URL.revokeObjectURL(imageUrl.value);
});

function getSubrecipeMeasurementByCompositionMeasurementId(compositionMeasurementId: number) {
  return props.subrecipeServingSizes.find(
    (rcm: RecipeCompositionMeasurement) => rcm.id === compositionMeasurementId
  )!.measurement;
}

return { __sfc: true,props, emit, imageUrl, getSubrecipeMeasurementByCompositionMeasurementId, desanitizeString }
}

})